import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs, query } from 'firebase/firestore';
import { outlets as jsonOutlets } from '../data/mock';

export const useOutlets = () => {
    const [outlets, setOutlets] = useState(jsonOutlets);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFirebaseOutlets = async () => {
            try {
                const q = query(collection(db, "outlets"));
                const querySnapshot = await getDocs(q);
                
                if (!querySnapshot.empty) {
                    const firebaseData = querySnapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    
                    // Merge or replace? 
                    // Usually, if they moved to Firebase, Firestore is the source of truth.
                    // But to prevent losing data from outlets.json, we can merge or use Firestore if it has more data.
                    // For now, let's just use Firestore if it's not empty, otherwise fallback to JSON.
                    setOutlets(firebaseData);
                }
            } catch (error) {
                console.error("Error fetching outlets from Firebase:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchFirebaseOutlets();
    }, []);

    return { outlets, loading };
};
